module.exports = __webpack_public_path__ + "img/Metastasis-CRC_10X_WTA.96d1cfa4.png";